document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("gallery-back");
  if (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      history.back();
    });
  }
});
